<template>
  <div v-if="has_filters" class="filters-tags">
    <p class="d-flex align-items-center justify-content-between">
      <span class="filters__section__title">Filtri attivi</span>
      <span class="filters-tags__clear" @click="remove_all_filters">
        cancella filtri
      </span>
    </p>
    <div class="filters-tags__badges">
      <b-badge
        pill
        variant="primary"
        class="filters-tags__badge"
        v-for="filter in shown_filters"
        :key="filter.key"
        @click="remove_filter(filter.key)"
      >
        <span>{{ filter.label }}</span>
        <span class="ml-2">&#10005;</span>
      </b-badge>
    </div>
  </div>
</template>

<script>
import {
  get_active_filters,
  remove_filter,
  remove_all_filters,
} from "@liveflight/utilities/filters";

export default {
  name: "filters-tags",
  computed: {
    has_filters() {
      return this.shown_filters.length;
    },
    shown_filters() {
      return this.get_active_filters()
    },
  },
  methods: {
    get_active_filters,
    remove_filter,
    remove_all_filters,
  },
};
</script>

<style lang="scss">
.filters-tags {
  &__clear {
    font-size: $font-size-sm;
    color: var(--info);
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      opacity: 0.85;
    }
  }

  &__badges {
    display: flex;
    flex-wrap: wrap;
  }

  &__badge {
    display: inline-flex;
    align-items: center;
    margin-right: $grid-gutter-width/4;
    margin-bottom: $grid-gutter-width/4;
    cursor: pointer;
    transition: $transition-base;

    &:hover {
      opacity: 0.85;
    }
  }
}
</style>
